// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DlZ6XlwGPcj9Eo {
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow: hidden;
  background: var(--ds-surface, #ffffff);
}
.DlZ6XlwGPcj9Eo:not(:empty) {
  padding: 4px 16px 8px;
}
.DlZ6XlwGPcj9Eo > * {
  overflow: hidden;
  transition: border-radius 0.2s ease-in-out;
  border-radius: 16px;
}
.c4T8oEVXtnUlzQ {
  transition: padding 0.2s ease-in-out;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"splitScreenBanners": `DlZ6XlwGPcj9Eo`,
	"bannersTransition": `c4T8oEVXtnUlzQ`
};
export default ___CSS_LOADER_EXPORT___;
